import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// SPA 換頁時自動捲回頂部（Rule 52）
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
